import {HourlyWeatherForecastItem} from '../../api/types';
import {now as clockNow} from '../Dates';

const DAY = 24 * 3600;

/**
 * The hours a "Next hours" card charts: after now and less than 24 h ahead.
 * A forecast's hourly list runs over days and starts in the past, and the
 * chart scales its line and its hours to whatever it is given.
 */
export const nextHours = <
  T extends Pick<HourlyWeatherForecastItem, 'timestamp'>,
>(
  hourly: T[],
  now: number = clockNow(),
): T[] => hourly.filter((f) => now < f.timestamp && f.timestamp < now + DAY);
